import React, { Component, PropTypes } from 'react'
import { Field } from 'redux-form'
import { Link } from 'react-router'

import './ServiceAddress.scss'
import MobileNavBar from 'components/MobileNavBar'
import AddressForm from './components/AddressForm'
import InputControl from 'components/InputControl'
import { analytics } from '@src/services/Analytics'
import * as paths from 'utils/paths'

import { LogOnMount } from '@amplitude/react-amplitude'

class ServiceAddress extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  _collectAddressSubmitAnalytics (formData) {
    const {
      address,
      keysLocation
    } = formData

    analytics.addressSubmit({
      street: address.street,
      extNumber: address.number,
      intNumber: address.interiorNumber,
      coloniaName: address.neighborhood,
      city: address.city,
      state: address.state,
      mapCenterpoint: {
        lat: address.lat,
        lng: address.lng
      },
      mapZoom: 16,
      entranceInstruction: keysLocation
    })
  }

  handleSubmit (data) {
    const {
      updateService,
      push,
      params: { aliadaId }
    } = this.props

    const formData = {
      service: {
        address: data.address,
        keysLocation: data.keysLocation
      },
      user: {
        phone: data.phone
      }
    }

    updateService(formData)
    this._collectAddressSubmitAnalytics(data)

    const confirmStepUrl = paths.bookingConfirmation(aliadaId)
    push(confirmStepUrl)
  }

  render () {
    const {
      handleSubmit,
      goBack
    } = this.props

    return (
      <div className='ServiceAddress navbar-screen'>
        <LogOnMount eventType="address-form-screen" />

        <MobileNavBar
          leftControl={
            <Link onClick={goBack}>
              <span className='icon-arrow-back' />
            </Link>
          }
          rightControl={<i className='icon-logo' />}
        >
          Introduce tu dirección
        </MobileNavBar>

        <div className='ServiceAddress-content navbar-screen-content'>
          <div className='navbar-screen-container'>
            <form onSubmit={handleSubmit(this.handleSubmit)}>
              <Field
                name='address'
                component={AddressForm}
                />

              <div className='ServiceAddress-fields'>
                <div className='ServiceAddress-phoneNumber'>
                  <Field
                    name='phone'
                    component={InputControl}
                    type='text'
                    label='Teléfono'
                    normalize={(value) => {
                      return value.replace(/\D/g, '')
                    }}
                    />
                </div>
              </div>

              <div className='ServiceAddress-keysLocation'>
                <h4>¿Cómo entrará tu Aliada?</h4>

                <div className='ServiceAddress-keysLocationInputs'>
                  <div className='ServiceAddress-inputWrapper'>
                    <Field
                      id='casa'
                      name='keysLocation'
                      value='home'
                      component='input'
                      type='radio' />
                    <label htmlFor='casa'>
                      Estaré en casa
                    </label>
                  </div>

                  <div className='ServiceAddress-inputWrapper'>
                    <Field
                      id='portero'
                      name='keysLocation'
                      value='withSomeone'
                      component='input'
                      type='radio' />
                    <label htmlFor='portero'>
                      Dejaré las llaves con el guardia/portero
                    </label>
                  </div>
                </div>
              </div>

              <div className='ServiceAddress-save'>
                <button
                  className='btn btn-primary btn-block btn-lg'
                  type='submit'>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}
ServiceAddress.displayName = 'ServiceAddress'
ServiceAddress.propTypes = {
  updateService: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  initialMapCenter: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  })
}

export default ServiceAddress



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/screens/ServiceAddress/ServiceAddress.js